import { FixingModel } from './fixing.model';

export class CurrencyModel {
  constructor(
    public id: number = null,
    public code: string = null,
    public label: string = null,
    public fixings: FixingModel[] = null,
    public blocked = false,
    public activated = true // public url: string = null,
  ) {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
